import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { EditSquare } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { formatCurrency, formatLicensePlate } from '../../../../utils/string';
import { AddressFields } from '../../../Address/components/AddressFields';
import { selectWorks } from '../../../Api/selectors';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { completeVehicleTransport, deleteVehicleProperty } from '../../../Vehicles/actions';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { refreshBoards } from '../../actions';
import {
  addVehicleToBulkActionsList,
  assignVehicleTransport,
  removeVehicleFromBulkActionsList,
} from '../../../Vehicles/actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { Cell } from '../Cell';
import { TransportAssignableOptions, TransportAssignableSortMap } from './Transport_1_nl_in';
import { Checkbox } from '../../../../components/Checkbox';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { selectVehicleBulkActionsKanbanTaskName, selectVehicleBulkActionsList } from '../../../Vehicles/selectors';
import {REQUEST_COMPANIES_PROPERTY} from "../../../Companies/constants";
import {selectCompanyProperty} from "../../../Companies/selectors";
import {REQUEST_ADDRESSES_BY_IDS} from "../../../Address/constants";
import {selectAddress} from "../../../Address/selectors";

const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }

  .regplate {
    font-size: 14px;
  }

  p {
    margin: 0;
  }

  .col-regplate-vin {
    max-width: 200px;
  }

  .col-model-info {
    min-width: 100px;
    max-width: 100px;
  }

  .col-address-from {
    min-width: 250px;
    max-width: 250px;
  }

  .col-address-to {
    min-width: 200px;
    max-width: 200px;
  }

  .col-status {
    min-width: 200px;
    max-width: 200px;
  }
  .info-block {
    white-space: nowrap;
  }

  font-size: 12px;
`;

const STATE = {
  approve: false,
  loading: false,
  confirmReset: false,
};

/* eslint-disable react/prefer-stateless-function */
class Transport_in_eu_planned_9Comp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  get action() {
    return this.props.action;
  }

  get bulkActionsList() {
    let list = [];
    if (this.props.bulkActionsList?.length) {
      list = this.props.bulkActionsList;
    }
    return list;
  }

  isSelectedVehicle() {
    return this.bulkActionsList?.filter(item => item?.id == this.vehicle?.id)?.length == 1;
  }

  onSelectVehicle(e, vehicle) {
    e.stopPropagation();
    if (this.isSelectedVehicle(vehicle?.id)) {
      return this.props.removeVehicleFromBulkActionsList(vehicle?.id);
    }

    return this.props.addVehicleToBulkActionsList(vehicle, this.action.functionName);
  }

  renderApprove() {
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.Transport_in_eu_planned_1.modal.title')}>
        {this.renderBody()}
      </Modal>
    );
  }

  renderBody() {
    const vehicle = this.vehicle;

    if (this.props.work || this.state.loading)
      return (
        <HBox center>
          <Loader small />
        </HBox>
      );
    return (
      <>
        <HBox center vCenter>
          <row>
            <VBox vCenter>
              <VBox className="regplate col-regplate-vin">
                <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
                <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
              </VBox>
              <VBox className="col-model-info">
                <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
                <p>{vehicle.model_name}</p>
              </VBox>
              <VBox className="address col-address-from">
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_incoming_from_company_name}
                  company_id={vehicle?.transport_incoming_from_company_id}
                />
                <AddressFields inlineshort addressId={vehicle.transport_from_address_id} />
              </VBox>
              <VBox className="address col-address-to"></VBox>
              <VehicleStatusLabel>{vehicle?.transporter_eu_in}</VehicleStatusLabel>
              <VBox>
                <VehiclePropertyEditableInput propertyName="amount_transport_eu_in" vehicle_id={this.vehicle.id} />
                <VehiclePropertyEditableInput propertyName="transporter_eu_in" vehicle_id={this.vehicle.id} />
                <VehiclePropertyEditableInput propertyName="date_expected_start_eu_in" vehicle_id={this.vehicle.id} />
                <VehiclePropertyEditableInput propertyName="amount_of_vehicles_in" vehicle_id={this.vehicle.id} />

                <VehiclePropertyEditableInput propertyName="transport_planned_incoming" vehicle_id={this.vehicle.id} />
              </VBox>
            </VBox>
          </row>
          {this.state.confirmReset ? (
            <VBox center>
              <div>{this.lbl('reset')}?</div>
              <HBox>
                <Button
                  onClick={() => {
                    this.setState({ loading: true });
                    this.props.resetTransport(() => {
                      this.reset();
                    });
                  }}
                >
                  {this.lbl('confirm')}
                </Button>
                <Button onClick={this.setStateFn({ confirmReset: false })}>{this.lbl('cancel')}</Button>
              </HBox>
            </VBox>
          ) : (
            <Button onClick={this.setStateFn({ confirmReset: true })}>
              <EditSquare />
              {this.lbl('reset')}
            </Button>
          )}
        </HBox>
        <ModalControls>
          {this.props.work ? (
            <Loader small />
          ) : (
            <>
              {/* <Button onClick={() => this.props.done(this.reset.bind(this))}>{this.lbl('complete')}</Button> */}
              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </>
          )}
        </ModalControls>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;

    return (
      <Cell>
        <Container
          style={{ backgroundColor: vehicle.transport_planned_incoming === '1' ? '#A5EBD6' : 'transparent' }}
          onClick={this.setStateFn({ approve: !this.state.approve })}
        >
          {this.props.cell.busy ? <Loader small /> : null}
          <HBox vCenter className="info-block">
            <Checkbox checked={this.isSelectedVehicle()} onChange={e => this.onSelectVehicle(e, vehicle)} />

            <VBox left className="regplate col-regplate-vin">
              <HBox vCenter>
                <VehicleStatusLabel>{vehicle?.transporter_eu_in}</VehicleStatusLabel>
                <VehicleStatusLabel color={'blue'}>in</VehicleStatusLabel>
              </HBox>
              <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
              <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>

              <p style={{ fontWeight: 600 }}>
                {vehicle.brand_name} {vehicle.model_name}
              </p>

              {this.props.companyName && (
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_incoming_from_company_name}
                  company_id={vehicle?.transport_incoming_from_company_id}
                />
              )}
              {this.props.address && (
                <AddressFields inlineshort addressId={vehicle?.transport_from_address_id} />
              )}

              <span style={{ fontWeight: 600 }}>
                {' '}
                {formatCurrency(vehicle?.amount_transport_eu_in)} &nbsp;&nbsp;
                {vehicle?.date_expected_start_eu_in}
              </span>
            </VBox>

            <VBox className="col-status">
              <HBox vCenter left autoWidth></HBox>
            </VBox>
          </HBox>
        </Container>
        {this.renderApprove()}
        <HBox style={{ fontSize: '12px' }} onClick={this.tofn(`/vehicles/${vehicle.id}`)}>
          {vehicle.id}{' '}
        </HBox>
      </Cell>
    );
  }
}

Transport_in_eu_planned_9Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_COMPANIES_PROPERTY,
      REQUEST_ADDRESSES_BY_IDS,
    ]),
    companyName: selectCompanyProperty(ownProps.cell.vehicle.transport_incoming_from_company_id, 'name'),
    address: selectAddress(ownProps.cell.vehicle.transport_from_address_id),
    bulkActionsList: selectVehicleBulkActionsList(),
    bulkActionTask: selectVehicleBulkActionsKanbanTaskName(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addVehicleToBulkActionsList(vehicle, kanbanTaskName) {
      dispatch(addVehicleToBulkActionsList(vehicle, [], kanbanTaskName));
    },
    removeVehicleFromBulkActionsList(vehicleId) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId));
    },
    resetTransport(callback) {
      let id = ownProps.cell.vehicle.id;
      dispatch(
        deleteVehicleProperty(ownProps.cell.vehicle.id, 'transport_assigned_to', () => {
          dispatch(
            deleteVehicleProperty(ownProps.cell.vehicle.id, 'transport_initiated', () => {
              dispatch(refreshBoards());
              callback();
            }),
          );
        }),
      );
    },
    done(callback) {
      let id = ownProps.cell.vehicle.id;
      const action_name = ownProps.action.functionName;
      dispatch(
        completeVehicleTransport(id, false, false, action_name, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Transport_in_eu_planned_9 = compose(withConnect, withRouter)(Transport_in_eu_planned_9Comp);
